export default "__VITE_PUBLIC_ASSET__27285bc1__"